import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectSubscriptionState = (state) =>
  state.creatorSubscription || initialState;

export const getCreatorSubscriptions = createSelector(
  [selectSubscriptionState],
  (subscriptionState) => subscriptionState.creatorSubscriptions
);

export const getCreatorSubscriptionDetails = createSelector(
  [selectSubscriptionState],
  (state) => state.creatorSubscriptionDetails
);

export const getChangePlanStatus = createSelector(
  [selectSubscriptionState],
  (state) => state.changePlan
);
